import { IProvider } from '@/shared/IProvider';
import { ProviderDialog } from './ProviderDialog'

export const EditProviderDialog = (props: {
  onClose: () => void;
  provider: IProvider;
  onSaveProvider: (provider: IProvider, invite: boolean) => Promise<void>;
}) => {

  return (
    <ProviderDialog
      onClose={props.onClose}
      provider={props.provider}
      onSave={props.onSaveProvider}
      saveLabel='Save'
      savingLabel='Saving...'
      title='Update EIT UM Course Provider'
      description='This will modify the existing course provider.'
    />
  )
}